module.exports = __webpack_public_path__ + "img/img.2ba45977.png";